import { Box } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useCD06RhqUrlInfoGet } from '../hooks/useCD06RhqUrlInfoGet'
import { LanguageContext } from '../util/LanguageContext'
import { VersionContext } from '../util/VersionContext'

type FooterDCPProps = {
  fixed?: boolean
}

export const FooterDCP = ({ fixed = true }: FooterDCPProps) => {
  const translation = useContext(LanguageContext)
  const { version } = useContext(VersionContext)
  const cd06 = useCD06RhqUrlInfoGet()
  const [privacyUrl, setPrivacyUrl] = useState('')
  const [termsUrl, setTermsUrl] = useState('')

  useEffect(() => {
    const fetchUrlInfo = async () => {
      const result = await cd06.execRhqUrlInfoGet()
      if (!result.success || !result.info) {
        return
      }

      setPrivacyUrl(result.info.privacy_statement_url ?? '')
      setTermsUrl(result.info.eura_url ?? '')
    }

    fetchUrlInfo()
  }, [])

  return (
    <Box
      sx={{
        px: 2,
        pt: 2,
        pb: 1,
        display: 'grid',
        gridTemplateColumns: '1fr auto auto auto',
        alignItems: 'center',
        columnGap: 3,
        font: 'normal normal normal 12px/12px Noto Sans JP',
        pointerEvents: 'none',
      }}
    >
      {/* コピーライトはKDC/TA同じ */}
      <Box>{translation['copyright_info']}</Box>

      {/* Privacy Statement */}
      {privacyUrl ? (
        <Box
          component='a'
          href={privacyUrl}
          target='_blank'
          rel='noreferrer'
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            '&:visited': {
              color: 'inherit',
            },
            '&:hover': {
              textDecoration: 'underline',
            },
            pointerEvents: 'auto',
          }}
        >
          {translation['label_privacy_statement']}
        </Box>
      ) : (
        <Box component='span' sx={{ color: 'inherit' }}>
          {translation['label_privacy_statement']}
        </Box>
      )}

      {/* Terms of Use */}
      {termsUrl ? (
        <Box
          component='a'
          href={termsUrl}
          target='_blank'
          rel='noreferrer'
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            '&:visited': {
              color: 'inherit',
            },
            '&:hover': {
              textDecoration: 'underline',
            },
            pointerEvents: 'auto',
          }}
        >
          {translation['label_terms_of_use']}
        </Box>
      ) : (
        <Box component='span' sx={{ color: 'inherit' }}>
          {translation['label_terms_of_use']}
        </Box>
      )}

      {/* バージョン情報 */}
      <Box sx={{ color: '#999999' }}>
        {version ? `${translation['app_version']}`.replace('{version}', version) : ''}
      </Box>
    </Box>
  )
}
